var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitor-event-list" } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _vm.events.length === 0
            ? _c("div", { staticClass: "no-events" }, [
                _c("div", { staticClass: "material-icons calendar-icon" }, [
                  _vm._v("calendar_today"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _vm._v("No events found"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.eventDates, function (eventDate) {
            return _c(
              "div",
              { staticClass: "events" },
              [
                _c("div", { staticClass: "date" }, [
                  _vm._v(_vm._s(_vm.getDay(eventDate))),
                ]),
                _vm._v(" "),
                _vm._l(_vm.getDateEvents(eventDate), function (event, index) {
                  return _c(
                    "div",
                    {
                      staticClass: "event",
                      on: {
                        click: function ($event) {
                          return _vm.getDetail(event._id)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "divider-content" }, [
                        _c("span", { class: index > 0 ? "divider" : "" }),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "event-content" }, [
                        _c("span", { staticClass: "time" }, [
                          _vm._v(_vm._s(_vm.getEventTime(event))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "infos" }, [
                          _c(
                            "span",
                            { staticClass: "info" },
                            [
                              _c("AgentAvatar", {
                                staticStyle: { "margin-right": "10px" },
                                attrs: { size: 30, userID: event.userId },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "detail" }, [
                                _c("span", { staticClass: "summary-title" }, [
                                  _vm._v(_vm._s(event.summary)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "description" }, [
                                  _vm._v(
                                    _vm._s(
                                      !!event.description
                                        ? event.description
                                        : "No content"
                                    )
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "row",
                              },
                            },
                            _vm._l(event.refUsers, function (refUser, index) {
                              return event.refUsers.length > 0
                                ? _c(
                                    "span",
                                    { staticClass: "other-users" },
                                    [
                                      _c("AgentAvatar", {
                                        class:
                                          index === event.refUsers.length - 1
                                            ? ""
                                            : "img-setting",
                                        attrs: {
                                          size: 25,
                                          userID: refUser._id,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.newEventModalVisible
            ? _c("CreateEventModal", {
                staticStyle: { "z-index": "999999 !important" },
                attrs: {
                  eventDetail: _vm.eventDetail,
                  calendarList: _vm.calendarList,
                },
                on: {
                  close: function ($event) {
                    _vm.newEventModalVisible = false
                  },
                  deleteEvent: function ($event) {
                    return _vm.deleteEventFunction($event)
                  },
                  editEvent: function ($event) {
                    return _vm.editEvent($event)
                  },
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }